import { HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CfgService } from "../../../../cfg/cfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

export class MonthTargetsCfg {
  public goalsEndPointPattern;
}

export class MonthlyTargetsKpiCfg {
  public monthTargets: MonthTargetsCfg;
  public enabled: boolean;
}

@Injectable()
export class MonthlyTargetsKpiCfgService extends CfgService<MonthlyTargetsKpiCfg> {
  json: any = {
    enabled: "%{MonthlyTargetEnabled}",
    monthTargets: {
      goalsEndPointPattern: "%{DashboardApiUrl}/monthlygoal"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/monthlyTargetsKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
